/**
 * @generated SignedSource<<9d5c673919f71d1ed7488b3962e67bc5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbRespQuickFilters_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SbRespQuickFilterDropdown_viewer">;
  readonly " $fragmentType": "SbRespQuickFilters_viewer";
};
export type SbRespQuickFilters_viewer$key = {
  readonly " $data"?: SbRespQuickFilters_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespQuickFilters_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespQuickFilters_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespQuickFilterDropdown_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "c71566bea2ae5770618990603e7ea285";

export default node;
